import React from 'react';

import {Icon, IconName} from '@udemy/icons';

import valuePropData from './data/value-prop-module-data.json';
import styles from './value-prop-module.module.less';

interface ValuePropModuleCardData {
    id: number;
    title1: string;
    title2?: string;
    copy: string;
    iconGlyph: string;
}

interface ValuePropModuleData {
    title: string;
    cards: ValuePropModuleCardData[];
}

const ValuePropModule = () => {
    const data = valuePropData as ValuePropModuleData;

    return (
        <div className={styles['value-prop-module-container']}>
            <h2 className={'ud-heading-serif-xxl'}>{data.title}</h2>

            <div className={styles['value-prop-module-cards-container']}>
                {data.cards.map(({id, title1, title2, copy, iconGlyph}) => (
                    <div key={id} className={styles['value-prop-module-card']}>
                        <div className={styles['value-prop-module-card-icon-container']}>
                            <Icon
                                glyph={iconGlyph as IconName}
                                label={false}
                                size="xlarge"
                                className={styles['value-prop-module-card-icon']}
                            />
                        </div>
                        <h3 className={styles['value-prop-module-card-title']}>
                            {title1}
                            {title2 && <br />}
                            {title2}
                        </h3>
                        <p className={styles['value-prop-module-card-copy']}>{copy}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export {ValuePropModule};
